/**
 * Separar los recibos de finiquito de los de la nómina ordinaria. Un solo criterio
 * para los lugares donde se imprimen, bajan o mandan recibos:
 *
 *   · TablaPrenomina — los submenús del menú Recibos (Ver e imprimir, Descargar,
 *     Enviar por correo).
 *   · PreNomina — filtra las líneas antes de abrir cada modal.
 *   · ModalVerRecibos — el tag del título y el nombre del archivo.
 *   · Recibos (consulta masiva) — el selector sobre la tabla.
 *
 * El finiquito cae DENTRO de la prenómina ordinaria (no hay prenómina aparte que
 * excluir), así que el marcador es `LineaPrenomina.finiquitoId`: sólo se llena en la
 * línea del empleado al que se le aplicó un finiquito y es null en las demás.
 *
 * El corte es por LÍNEA, igual que en la Lista de Raya (listaRayaExcel.js): la línea
 * de un finiquito paga también el sueldo de los días trabajados antes de la baja, y
 * todo eso va con "Sólo finiquitos". Si hubo CFDI de separación, sus dos recibos van
 * juntos. Los sufijos de archivo son los mismos que ya usa la Lista de Raya.
 */

/**
 * Las tres variantes, en el orden de la Lista de Raya. La ORDINARIA va primera y
 * resaltada porque es la de rutina: la nómina del periodo sin que las liquidaciones
 * se mezclen.
 */
export const OPCIONES_FINIQUITO = [
  { valor: 'sin',   etiqueta: 'Ordinaria (sin finiquitos)', destacada: true },
  { valor: 'todos', etiqueta: 'Todos (con finiquitos)' },
  { valor: 'solo',  etiqueta: 'Sólo finiquitos' },
]

const esFiniquito = (l) => !!(l?.finiquitoId || l?.esFiniquito)

/**
 * `'sin'` deja fuera las líneas de finiquito, `'solo'` deja sólo ésas y cualquier otro
 * valor (`'todos'`, undefined) devuelve el arreglo tal cual — así quien no pasa filtro
 * se queda exactamente con lo de antes.
 *
 * Acepta también `esFiniquito`, que es como lo manda la consulta masiva de recibos.
 */
export const filtrarPorFiniquito = (lineas, filtro) => {
  const todas = lineas || []
  if (filtro === 'sin')  return todas.filter(l => !esFiniquito(l))
  if (filtro === 'solo') return todas.filter(esFiniquito)
  return todas
}

/** Hay al menos una línea de finiquito: sólo entonces se ofrecen las variantes. */
export const hayFiniquitos = (lineas) => (lineas || []).some(esFiniquito)

/** Va en el nombre del archivo, para que las tres descargas de un periodo no se pisen. */
export const sufijoFiniquito = (filtro) =>
  filtro === 'sin' ? '_sin_finiquitos'
    : filtro === 'solo' ? '_solo_finiquitos'
    : ''

/** Para el tag del título del visor; null cuando no hay filtro que avisar. */
export const etiquetaFiniquito = (filtro) =>
  filtro === 'sin' ? 'Ordinaria'
    : filtro === 'solo' ? 'Sólo finiquitos'
    : null

/** Para el aviso cuando la variante elegida no trae ningún recibo. */
export const mensajeSinRecibos = (filtro) =>
  filtro === 'sin' ? 'No hay recibos de nómina ordinaria en esta selección'
    : filtro === 'solo' ? 'No hay recibos de finiquito en esta selección'
    : null
